export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: 'ri-download-cloud-line',
      title: 'Download',
      description: 'Get AGIT VPN for your device in seconds from our website or app store'
    },
    {
      number: '2',
      icon: 'ri-install-line',
      title: 'Install',
      description: 'Quick and easy installation process with step-by-step guidance'
    },
    {
      number: '3',
      icon: 'ri-link',
      title: 'Connect',
      description: 'Choose your preferred server location and connect with one click'
    },
    {
      number: '4',
      icon: 'ri-shield-check-line',
      title: 'Browse Securely',
      description: 'Enjoy complete privacy and freedom while browsing the internet'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Simple Setup Process
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get started with AGIT VPN in just a few minutes
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-lg">{step.number}</span>
                  </div>
                </div>

                <div className="mt-8 mb-6">
                  <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-purple-100 rounded-2xl flex items-center justify-center mx-auto">
                    <i className={`${step.icon} text-blue-600 text-4xl`}></i>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
